const galleries = document.querySelectorAll('.wp-block-gallery');

galleries.forEach(gallery => {
  let links = gallery.querySelectorAll('a');

  links.forEach(link => {
    link.setAttribute('data-fslightbox', 'gallery');
  });
});

refreshFsLightbox();


if (fsLightboxInstances["gallery"]) {
  fsLightboxInstances["gallery"].props.onOpen = function() {
    // console.log(this);
    let lightboxContainer = document.body.querySelector('.fslightbox-container');
    this.donloadModule = new LightboxDownload(lightboxContainer, this);
    this.videoPosterModule = new LightboxVideoPoster(lightboxContainer, this);
  }
}

class LightboxDownload {
  constructor(container, instance) {
    this.container = container;
    this.toolbar = this.container.querySelector('.fslightbox-toolbar');
    this.activeSlideIndicator = this.container.querySelector('.fslightbox-slide-number-container span');
    this.targetSrcs = instance.sources;
    this.init();
  }
  init() {
    this.createBtn();

    this.activeSlide = Number(this.activeSlideIndicator.innerText);
    // console.log(this.activeSlide);
    this.updateDownloadBtn();

    this.observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        for (const addedNode of mutation.addedNodes) {
          if (addedNode.nodeName == '#text') {
            this.activeSlide = Number(addedNode.textContent);
            // console.log(this.activeSlide);
            this.updateDownloadBtn();
          }
        }
      }
    });
    this.observer.observe(this.container, {childList: true, subtree: true, characterData: true});
  }
  createBtn() {
    let btn = this.container.querySelector('.download-btn');
    if (btn) {
      this.btn = btn;
      return;
    }
    this.btn = document.createElement('a');
    this.btn.classList = 'fslightbox-toolbar-button fslightbox-flex-centered download-btn';
    this.btn.title = 'Download image';
    this.btn.innerHTML = '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="20" height="20"><path class="fslightbox-svg-path" d="M9.878,18.122a3,3,0,0,0,4.244,0l3.211-3.211A1,1,0,0,0,15.919,13.5l-2.926,2.927L13,1a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1l-.009,15.408L8.081,13.5a1,1,0,0,0-1.414,1.415Z"/><path class="fslightbox-svg-path" d="M23,16h0a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V17a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v4a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V17A1,1,0,0,0,23,16Z"/></svg>';
    this.btn.setAttribute('download', true);
    this.toolbar.prepend(this.btn);
  }
  updateDownloadBtn() {
    let targetSrc = this.targetSrcs[this.activeSlide - 1];
    this.btn.href = targetSrc;
    let filename = targetSrc.substring(targetSrc.lastIndexOf('/') + 1);
    // console.log(filename);
    if (filename.indexOf('?')) filename = filename.substring(0, filename.indexOf('?'));
    // console.log(filename.indexOf('?'), filename);
    this.btn.download = filename;
  }
}

class LightboxVideoPoster {
  constructor(container, instance) {
    this.container = container;
    this.activeSlideIndicator = this.container.querySelector('.fslightbox-slide-number-container span');
    this.targetSrcs = instance.sources;
    this.init();
  }
  init() {
    this.activeSlide = Number(this.activeSlideIndicator.innerText);
    // console.log(this.activeSlide);
    this.addPoster();

    this.observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        for (const addedNode of mutation.addedNodes) {
          if (addedNode.nodeName == '#text') {
            this.activeSlide = Number(addedNode.textContent);
            // console.log(this.activeSlide);
            this.addPoster();
          }
        }
      }
    });
    this.observer.observe(this.container, {childList: true, subtree: true, characterData: true});
  }
  addPoster() {
    let video = this.container.querySelector('video');
    // console.log('video', video);
    if (! video) return;
    let targetSrc = this.targetSrcs[this.activeSlide - 1];
    let link = document.querySelector(`a[href="${targetSrc}"][data-fslightbox="gallery"]`);
    // console.log('link', link);
    if (! link) return;
    let img = link.querySelector('img');
    // console.log('img', img);
    if (! img) return;
    video.poster = img.src;
  }
}
